import styled from 'styled-components';
import { TimePicker as BPTimePicker } from '@blueprintjs/datetime';
export var StyledTimeInput = styled(BPTimePicker).withConfig({
  displayName: "TimeInputstyled__StyledTimeInput",
  componentId: "sc-w46azk-0"
})([""]);